import { useState } from "react";
import { IoMdArrowDropdown } from "react-icons/io";
import "./TextBubble.css"

export default function TextBubble({ title="", doLoadExpanded = true, children}) {
    const [isExpanded, setIsExpanded] = useState(doLoadExpanded);

    function handleOnClick() {
        setIsExpanded(!isExpanded);
    }

    return(
        <div className={`text-bubble ${ isExpanded ? "" : "collapsed"}`}>
            {title !== "" ? (
                <div className={`title-dropdown ${ isExpanded ? "" : "collapsed"}`} onClick={handleOnClick}>
                    <h1>{title}</h1>
                    <IoMdArrowDropdown size={"2em"} />
                </div>) : null}
            <div className="text-bubble-content">
                <div style={{padding: "10px"}}>
                    {children}
                </div>
            </div>
        </div>
    );
}